export const NO_SOLUTION_GENERATED = {
  key: "no-solution-generated",
  message: "Error: Grades must have students",
}
export const NO_SOLUTION_FOUND = { key: "no-solutions-found" }
